import { Translatable } from "@icc/shared/helpers";

export class InspectionHatchSupportBracket {
    id: number;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Ilość wsporników */
    amount: number;
    isDefault?: boolean;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type?: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}


export interface IccInspectionHatchSupportBracket {
    id: number;
    name: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do wydruków */
    printCode?: string;
    /** Ilości */
    amounts: {
        /** Minimalna szerokość */
        min_width: number;
        /** Maksymalna szerokość */
        max_width: number;
        /** Ilość */
        amount: number;
        /** Typ wyboru */
        selection_type?: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Przypisane profile */
    profilesIds: number[];
    /** ID kategorii akcesoriów */
    categoryId?: number;
    /** Nazwa kategorii akcesoriów */
    categoryName?: string;
}
